import React from 'react'
import Search from 'Documents/publish/components/search/search'

const SearchWrapper = ({ themeColor, versionId, setShowSearchModal }) => (
  <Search themeColor={themeColor} versionId={versionId} setShowSearchModal={setShowSearchModal} />
)

export default SearchWrapper
